const STORAGE_KEY = "studyGroup";

export const getLastStudyGroupId = (): number | null => {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { studyGroupId?: number };
    const id = parsed?.studyGroupId;
    return typeof id === "number" ? id : null;
  } catch {
    return null;
  }
};

export const setLastStudyGroupId = (studyGroupId: number | null) => {
  if (typeof localStorage === "undefined") return;
  try {
    if (studyGroupId == null) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ studyGroupId }));
  } catch {
    // no-op on storage failure
  }
};
